// @ts-check
/**
 * @param {keyof CaseData} name
 * @param {any} [fallback] Value to return if the property does not exist
 * @returns {(caseData: CaseData) => any}
 */
export const getCasePropSelector = (name, fallback = null) => caseData =>
  caseData && caseData.hasOwnProperty(name) ? caseData[name] : fallback
